import { render } from "./Documents.vue?vue&type=template&id=71b2633a&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=71b2633a&lang=scss"
import "./Documents.vue?vue&type=style&index=1&id=71b2633a&lang=scss&scoped=true"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b2633a"]])

export default __exports__